module.exports = __webpack_public_path__ + "img/full5-min.8b2feb04.png";